export { FileInput } from './file-input';
export type { FileInputProps, FileInputStylesNames } from './file-input';
